<template>
  <div class="agency-content" :style="backgroundStyles">
    <!-- Img overlay -->
    <div class="overlay"></div>

    <ModalEligibleAgency
      :display="displayEligibilityInfo"
      :agency="agency"
      :noAgencyMessage="noAgencyMessage"
      :cta="universCta"
      @hideAgencyInfos="closeAgencyModal"
    />

    <div class="content-wrapper">
      <p :inner-html.prop="blockdatas.title"></p>

      <form @submit.prevent="submitFormValues">
        <!-- Input Postal Code -->
        <div class="form-section Form-inputText">
          <div class="logo-map"></div>
          <svg
            v-svg
            symbol="Map"
            size="0 0 20 20"
            role="presentation"
            class="icon--inline Icon-Map"
          ></svg>
          <input
            type="tel"
            id="postal-code"
            name="postalCode"
            minlength="5"
            maxlength="5"
            class="topLabel"
            ref="postalCodeInput"
            max="99999"
            required
          />
          <label for="postal-code">Code postal</label>
        </div>

        <!-- Select Univers -->
        <div class="form-section">
          <select name="univers" id="univers-select" ref="universInput" required>
            <option value="" selected disabled hidden>Type d'intervention</option>
            <option
              v-for="univers in blockdatas.universesData"
              :key="univers.entity_id"
              :value="univers.entity_id"
            >
              {{ univers.name }}
            </option>
          </select>
        </div>

        <!-- Button Submit -->
        <div class="form-section">
          <input type="submit" class="Button Button-danger" :value="blockdatas.label" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TopLabelMixin from "@/mixins/topLabelMixin";
import InstanceApi from "@/services/apiClient.js";
import ModalEligibleAgency from "@/components/Modal/ModalEligibleAgency.vue"
export default {

  name: "EligibleAgency",

  components: { ModalEligibleAgency },

  mixins: [TopLabelMixin],

  props: ["blockdatas"],

  computed: {
    backgroundStyles() {
      return {
        "background-image": `url(${this.blockdatas.background_image})`,
        "background-size": "cover",
        "background-position-y": "10%",
      };
    },
  },

  data() {
    return {
      displayEligibilityInfo: false,
      agency: {},
      universCta: null,
      noAgencyMessage: "",
    };
  },

  methods: {
    submitFormValues() {
      this.verifyEligibility(this.$refs.universInput.value, this.$refs.postalCodeInput.value);

      this.blockdatas.universesData.forEach((univers) => {
        if (univers.entity_id === this.$refs.universInput.value) {
          this.universCta = univers.cms_cta;
        }
      });

      this.displayEligibilityInfo = true;
    },

    verifyEligibility(category, postalCode) {
      const addUrl = `mcp/agency/get/category/${category}/zipcode/${postalCode}`;
      this.callApi(addUrl);
    },

    async callApi(addUrl) {
      await InstanceApi.get(addUrl)
        .then((response) => {

          if (response.data instanceof Object) {
            this.notEligibleMessage = "";
            this.agency = response.data;
          } else {
            this.agency = {};
            this.noAgencyMessage = response.data;
          }

        })
        .catch((e) => {
          /** Error Message */
          this.$fire({
            title: "Oups",
            text: "Impossible de charger les informations de l'agence",
            type: "error",
            timer: 1500,
            position: "top-end",
          });
        });
    },

    closeAgencyModal() {
      this.displayEligibilityInfo = false;
      this.agency = {};
      this.noAgencyMessage = "";
    },
  },

};
</script>

<style lang="scss">
.agency-content {
  position: relative;
  padding: 40px 0;
  height: 340px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ($mq-desktop) {
    padding: 83px 0;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .content-wrapper {
    width: 640px;
    z-index: 2;

    @media ($mq-desktop) {
      width: 840px;
    }

    p {
      font-size: 2.6rem;
      color: $color-white;
      line-height: 1.1;
      text-align: center;
      margin-bottom: 25px;

      @media ($mq-desktop) {
        font-size: 3.6rem;
      }
    }

    form {
      display: flex;
      align-items: center;
      border-radius: 32px;
      background-color: $color-white;
      padding: 3px;
      overflow: hidden;

      @media ($mq-phone) {
        flex-direction: column;
        margin: 0 auto;
        width: 300px;
        padding: 5px;

        .form-section {
          width: 100%;
        }

        .agency-content .content-wrapper form .Icon-Map {
          margin-left: 10px;
        }
      }

      /* Icon */
      .logo-map {
        display: none;
        background: url(../../assets/icons/mcp/Map.svg);
        background: url(../../assets/icons/mcp/Phone.svg);
      }
      .Icon-Map {
        margin-left: 20px;
        fill: $color-red;
      }

      .form-section {
        flex: 1;
      }

      /* Input postal-code */
      .Form-inputText {
        position: relative;
        display: flex;
        align-items: center;

        &:after {
          content: "";
          position: absolute;
          top: 25%;
          right: 0;
          width: 1px;
          height: 50%;
          background-color: $color-gray-2;
        }
      }
      input[type="tel"] {
        margin-top: 0;
        border: none !important;
      }
      .Form-inputText input.topLabel + label {
        top: 15px;
        left: 45px;
      }
      .Form-inputText input.topLabel.focused + label {
        top: 5px;
        left: 45px;
      }

      /* Select input */
      select {
        background-color: #fff;
      }

      /* Button submit */
      .Button-danger {
        box-shadow: none;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
